import {useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import {usePricingDiscountRoleConfig} from "../../@hooks";
import {elementsInLoading, evolutionSkuDataFilters, evolutionOffersDataFilters} from "../../@signals";


export default function usePriceDiscountWidget() {
	const { urlApi } = usePricingDiscountRoleConfig()

	const isLoading = useSignal(false)
	const data = useSignal([])
	const chartColors = useSignal([])

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoading.value = true
			data.value = []
			evolutionSkuDataFilters.value = {}
			evolutionOffersDataFilters.value = {}
			postSubmit(`${urlApi}/widgets`, { ...commonFiltersValue.value }).then(res => {
				data.value = res.widgetsData
				chartColors.value = res.widgetsColor
			}).catch(() => {
				isLoadingCommonFilters.value = false
				isSystemBusy.value = true
			}).finally(() => isLoading.value = false)
		}
	}, [isLoadingCommonFilters.value]);

	useEffect(() => {
		if (isLoading.value)
			elementsInLoading.value = [...elementsInLoading.value, 'widget']
		else
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'widget')
	}, [isLoading.value])

	return {
		isLoading: isLoading.value,
		data: data.value,
		chartColors: chartColors.value
	}
}